'use strict';

var { find } = require('underscore'),
    SectionTypes = require('../constants/SectionTypes'),
    MediaTypes = require('../constants/MediaTypes');

function getFirstAudioSection(stamp) {
  if (!stamp || !stamp.content) {
    return null;
  }

  return find(stamp.content.sections, s => (
    s.type === SectionTypes.MEDIA && (
      s.mediaType === MediaTypes.AUDIO_TRACK ||
      s.mediaType === MediaTypes.AUDIO_PLAYLIST
    )
  ));
}

module.exports = getFirstAudioSection;


/** WEBPACK FOOTER **
 ** ./utils/getFirstAudioSection.js
 **/